import React, { useState, useEffect } from 'react';
import { useRollbar } from '@rollbar/react';

const NoteErorrBoundary = ({ children }) => {
  const [hasError, setHasError] = useState(false);
  const [error, setError] = useState(null);
  const rollbar = useRollbar();

  useEffect(() => {
    const handleError = (_error, info) => {
      /* eslint-disable-next-line no-console */
      console.error('Error boundary caught',  _error, info);
      setHasError(true);
      setError(_error);
    };

    window.addEventListener('error', handleError);

    return () => {
      window.removeEventListener('error', handleError);
    };
  }, []);

  if (hasError) {
    const { jsonContent, isTemplate, id }  = children?.props || {};
    const message = `${isTemplate ? 'Template' : 'Note'} ${id} crashed`;
    rollbar.error(message, error, { id, noteContents: JSON.stringify(jsonContent) });
    return (
      <div>
        We're sorry. Something happened in the note editor and it has crashed. Please try refreshing
        to see if your note was saved, otherwise contact support and we might be able to recover it.
      </div>
    );
  }
  return children;
};

export default NoteErorrBoundary;
